import React from 'react';
import SweetAlert from 'sweetalert-react';

const SuccessAlert = props => (
  <SweetAlert
    title="Success"
    type="success"
    {...props}
  />
  );

export default SuccessAlert;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/SuccessAlert.jsx